import mascot from "./mascot.webp";
import styles from "./ArtEva.module.css";

type ArtEvaProps = {
  width: number;
  /** `full` — маскот целиком (Figma 933:3160), `peek` — выглядывает снизу, как в превью E-va (Figma 933:3554). */
  crop?: "full" | "peek";
  className?: string;
};

/** Art‑Eva: растровый маскот в кадрирующей рамке. */
export function ArtEva({ width, crop = "full", className }: ArtEvaProps) {
  return (
    <div className={[styles.art, styles[crop], className].filter(Boolean).join(" ")} style={{ width }}>
      <img className={styles.image} src={mascot} alt="" />
    </div>
  );
}
